import styled from "styled-components";
import { P } from "../";
export const Footnote = styled(P)`
  font-size: 11px;
  font-style: italic;
  font-weight: 300;
  line-height: 14px;
`;